import CustomerItem from '../../helperTypes/CustomerItem';

/**
 * Returns how many "infractions" the driver has
 *
 * @param customer - The source driver
 */
export default function calculateFouls(customer: CustomerItem): number {
  const { offensesQty, collisionsQty, exonerationQty } = customer;
  const numFouls = offensesQty + collisionsQty - exonerationQty;
  return numFouls >= 3 ? 3 : numFouls;
}
